import { render, staticRenderFns } from "./lsCollFromCenterList.vue?vue&type=template&id=452ebdde&scoped=true&"
import script from "./lsCollFromCenterList.vue?vue&type=script&lang=js&"
export * from "./lsCollFromCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ebdde",
  null
  
)

export default component.exports